import './SwitchgearCounter.scss';

export { default } from './SwitchgearCounter';
